
module.exports = (text) => (
    text.toLowerCase()
        .replace(/\s+/g, '-')           // spaces become dashes
        .replace(/[^\w\-]+/g, '')       // non-letters go away
        .replace(/\-\-+/g, '-')         // dash sequences collapse
);
